import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';

interface Props extends Omit<React.HTMLAttributes<HTMLLIElement>, 'title'> {
  title?: React.ReactNode;
  className?: string;
}

/**
 * MenuDivider - typicky pro dropdown menu.
 */
const MenuDivider: React.FC<Props> = React.forwardRef<HTMLLIElement, Props>(
  ({ title, className, ...restProps }, ref) => {
    const usedClassName = classNames(
      {
        [Classes.MENU_DIVIDER]: !title,
        [Classes.MENU_SECTION]: !!title,
      },
      className
    );
    return (
      <li ref={ref} className={usedClassName} {...restProps}>
        {title ?? null}
      </li>
    );
  }
);

export { MenuDivider };
